import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { activityLogsKeys } from './getActivityLogs';
import { fileDetailsKeys } from './getFileDetails';

import { isResponseError } from '../../../../api/config';
import { entryActionCustomValidateOptions } from '../../../../api/inbox';
import { UpdateFileEntryResponse } from '../../../../types';
import { updateSidebarInboxEntry } from '../../../Sidebar/api/inboxEntries';

const url = `${PREFIX_URL}/inbox-documents/:fileId/rename`;

export type RenameFileDTO = {
  fileId: number;
  newName: string;
};

export const renameFile = ({
  fileId,
  newName,
}: RenameFileDTO): Promise<UpdateFileEntryResponse> => {
  return axios.put(
    generateRoutePath(url, { fileId }),
    { 'new-name': newName },
    {
      ...entryActionCustomValidateOptions,
    }
  );
};

type useRenameFileOptions = {
  fileId: number;
  projectId: string;
  config?: MutationConfig<typeof renameFile>;
};

export const useRenameFile = ({ fileId, projectId, config }: useRenameFileOptions) => {
  return useMutation({
    onSuccess: (data) => {
      if (isResponseError(data)) {
        return;
      }

      queryClient.setQueryData([...fileDetailsKeys.detail({ fileId })], (prev: any) => {
        return {
          ...prev,
          data: data.data['inbox-document'],
        };
      });

      queryClient.invalidateQueries([...activityLogsKeys.list(fileId)]);

      if (projectId) {
        updateSidebarInboxEntry({ projectId, newInboxEntry: data.data['inbox-entry'] });
      }
    },
    ...config,
    mutationFn: ({ newName }) => renameFile({ fileId, newName }),
  });
};
